import React from "react";
import "./Nav.scss";
import Logo from "../../images/logo.png";
import { Link } from "react-router-dom";
import { useStoreActions, useStoreState } from "easy-peasy";

const NavComponent = () => {
  const menuActive = useStoreState((state) => state.something.menuActive);
  const setMenuActive = useStoreActions(
    (actions) => actions.something.setMenuActive
  );
  const paths = useStoreState((state) => state.path.paths);
  const careerPaths = useStoreState((state) => state.careerPath.paths);

  return (
    <div className="navMain fullFlex">
      <div className="container">
        <Link to="/">
          <div className="logo">
            <img src={Logo} alt="Logo" />
          </div>
        </Link>
        <div
          className={!menuActive ? "menuIcon" : "menuIcon menuActiveIcon"}
          onClick={() => setMenuActive(!menuActive)}
        >
          <div className="greenLine greenLine-top"></div>
          <div className="greenLine greenLine-middle"></div>
          <div className="greenLine greenLine-bottom"></div>
        </div>
        <div className="list">
          <ul>
            <li className="dd-wrapper">
              <Link to="/about">О компании</Link>
              <ul className="dd-list fullFlex dinamik">
                <li>
                  <Link to="/management">Руководство</Link>
                </li>
                <li>
                  <Link to="/documents">Документы</Link>
                </li>
                <li>
                  <Link to="/news">Новости</Link>
                </li>
                <li>
                  <Link to="/purchase">Закупки</Link>
                </li>
                <li>
                  <Link to="/security">Охрана труда</Link>
                </li>
                <li>
                  <Link to="/actives">Непрофильные активы</Link>
                </li>
              </ul>
            </li>
            <li className="dd-wrapper">
              <Link to="/deals">Покупателям</Link>
              <ul className="dd-list fullFlex dinamik">
                <li>
                  <Link to="/deals">Акции</Link>
                </li>
                <li>
                  <Link to="/bonus">Бонусная программа</Link>
                </li>
                <li>
                  <Link to="/privilege">Льготное обеспечение</Link>
                </li>
                <li>
                  <Link to="/production">Изготовление лекарств</Link>
                </li>
                <li>
                  <Link to="/optica">Оптика</Link>
                </li>
                <li>
                  <Link to="/legal">Оптовым покупателям</Link>
                </li>
              </ul>
            </li>
            <li className="dd-wrapper">
              <Link to="/rent">аренда</Link>
            </li>
            <li className="dd-wrapper">
              <Link to="/storenetwork">аптечная сеть</Link>
            </li>
            {careerPaths && careerPaths.length > 0 && (
              <li className="dd-wrapper">
                <a>Карьера</a>
                <ul
                  className="dd-list fullFlex dinamik"
                  style={{ width: "auto", minWidth: "100px" }}
                >
                  {careerPaths.map((el, ind) => (
                    <li key={ind}>
                      <Link to={`/career/${el.path}`}>{el.title}</Link>
                    </li>
                  ))}
                </ul>
              </li>
            )}
            {paths && paths.length > 0 && (
              <li className="dd-wrapper">
                <a>Актуальное</a>
                <ul
                  className="dd-list fullFlex dinamik"
                  style={{ width: "auto", minWidth: "100px" }}
                >
                  {paths.map((el, ind) => (
                    <li key={ind}>
                      <Link to={`/extra/${el.path}`}>{el.title}</Link>
                    </li>
                  ))}
                </ul>
              </li>
            )}
            <li className="dd-wrapper" style={{ zIndex: "0" }}>
              <Link to="/contacts">контакты</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NavComponent;
